/**
 * @module app.bdc.reports.bundleElectronicSignatureCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function BundleElectronicSignatureCtrl($rootScope, $window) {
        var self = {};
        self.client = $rootScope.order.client;
        self.order = $rootScope.order;

        /**
         * Is TPE option ?
         * @return {Boolean}
         */
        self.isTPE = function isTPE() {
            for (var i = 0; i < self.order.options.length; i++) {
                if (
                    self.order.options[i].optionType.code === 'TPE' ||
                    self.order.options[i].optionType.code === 'LADDITION_TPE'
                ) {
                    return true;
                }
            }
        };

        // Modification du title de la page pour l"impression en PDF
        $window.document.title =
            self.client.lastName +
            '_' +
            self.client.firstName +
            '_' +
            'BonDeCommande' +
            '_' +
            moment().format('YYYYMMDD');

        return self;
    }

    BundleElectronicSignatureCtrl.$inject = ['$rootScope', '$window'];

    angular
        .module('app.bdc.reports.bundleElectronicSignatureCtrl', [])
        .controller('BundleElectronicSignatureCtrl', BundleElectronicSignatureCtrl);
});
